/*
  Utilitech: product-page quote / trade CTAs (2026-10-10).
  Opens, prefills and scrolls to the native #product-request-form (Shopify
  form 'contact'). Never submits anything itself: the form's own submit button
  does, so form_type=contact and the ?contact_posted=true success redirect used
  by the Google Ads custom pixel are untouched.
  Markup + config: snippets/utilitech-pdp-quote-cta.liquid
*/
(function () {
  'use strict';
  var cfg = window.utQuote || {};
  var form = document.getElementById('product-request-form');
  if (!form || form.dataset.utQuoteInit) return;
  form.dataset.utQuoteInit = '1';

  var details = form.querySelector('details');
  var userTyped = false;
  function msgEl() { return form.querySelector('textarea[name="contact[message]"]'); }
  var m0 = msgEl();
  if (m0) m0.addEventListener('input', function () { userTyped = true; });

  function scrollToForm() {
    var offset = window.innerWidth < 720 ? 150 : 120;
    var y = form.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function openForm(type) {
    if (details) details.open = true;
    var radio = form.querySelector('[data-ut-reqtype="' + type + '"]');
    if (radio) radio.checked = true;
    var src = form.querySelector('[data-ut-source]');
    if (src) src.value = type === 'trade' ? 'Product page - trade pricing link' : 'Product page - quote button';
    var qField = form.querySelector('input[name="contact[quantity]"]');
    var qtyIn = document.querySelector('[data-product-form] [data-quantity-input]');
    if (qField && !qField.value && type !== 'trade') {
      qField.value = (qtyIn && qtyIn.value) || 1;
      qField.classList.add('form-field-filled');
    }
    var msg = msgEl();
    if (msg && !userTyped) {
      var part = cfg.sku ? ' (Part no. ' + cfg.sku + ')' : '';
      msg.value = type === 'trade'
        ? 'Trade pricing request: ' + cfg.title + part + '. Please send trade/volume pricing and account application details.'
        : 'Quote request: ' + cfg.title + part + '. Please quote incl. delivery to: ';
      msg.classList.add('form-field-filled');
    }
    scrollToForm();
    var first = form.querySelector('#product-request-form__name');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 500);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ut-quote-open]');
    if (!t) return;
    e.preventDefault();
    openForm(t.getAttribute('data-ut-quote-open'));
  });

  // Deep links: ?quote=1 / ?quote=trade / #quote (ignored after a submit)
  var params = new URLSearchParams(window.location.search);
  var hasError = !!form.querySelector('.product-request-form__error-message');
  if (hasError) {
    window.addEventListener('load', function () { setTimeout(scrollToForm, 50); });
  } else if (!params.get('contact_posted') && (params.get('quote') || window.location.hash === '#quote')) {
    window.addEventListener('load', function () { openForm(params.get('quote') === 'trade' ? 'trade' : 'quote'); });
  }

  // Optional separate analytics count (URL-based conversion stays primary)
  form.addEventListener('submit', function () {
    try {
      var r = form.querySelector('[name="contact[Request type]"]:checked');
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('ut_quote_submit', { type: r ? r.value : 'Quote', sku: cfg.sku || '' });
      }
    } catch (e) {}
  });

  // Mobile sticky bar (<720px): visible only once the native Add to cart has
  // scrolled up out of view; hidden while the request form is OPEN and on
  // screen (the collapsed one-line accordion row does not hide it).
  function currentAtc() { return document.querySelector('[data-product-form] [data-product-atc]'); }
  var atc0 = currentAtc();
  if (!atc0) return;
  var bar = document.createElement('div');
  bar.className = 'ut-sticky';
  bar.setAttribute('aria-hidden', 'true');
  bar.setAttribute('data-ut-sticky', '');
  var priceBox = document.createElement('div');
  priceBox.className = 'ut-sticky__price';
  priceBox.textContent = cfg.price || '';
  var small = document.createElement('small');
  small.textContent = cfg.vat || '';
  priceBox.appendChild(small);
  var q = document.createElement('button');
  q.type = 'button'; q.className = 'ut-sticky__btn ut-sticky__btn--sec';
  q.setAttribute('data-ut-quote-open', 'quote'); q.textContent = 'Quote';
  var a = document.createElement('button');
  a.type = 'button'; a.className = 'ut-sticky__btn ut-sticky__btn--pri';
  a.textContent = (atc0.querySelector('.atc-button--text') || atc0).textContent.trim() || 'Add to cart';
  if (atc0.disabled) a.disabled = true;
  // Always click the CURRENT native ATC (Empire may re-render the form), same cart flow.
  a.addEventListener('click', function () { var b = currentAtc(); if (b) b.click(); });
  bar.appendChild(priceBox); bar.appendChild(q); bar.appendChild(a);
  document.body.appendChild(bar);

  // Scroll-position based (not IntersectionObserver on a node that the theme
  // may replace): re-query the ATC each frame we need it.
  var ticking = false;
  function update() {
    ticking = false;
    var atc = currentAtc();
    var ab = atc ? atc.getBoundingClientRect() : null;
    var atcAbove = !!(ab && ab.height && ab.bottom < 0);
    var fr = form.getBoundingClientRect();
    var formVisible = fr.top < window.innerHeight && fr.bottom > 0;
    var formOpen = !!(details && details.open);
    var show = atcAbove && !(formVisible && formOpen) && window.innerWidth < 720;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  function schedule() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if (details) details.addEventListener('toggle', schedule);
  update();
})();
